<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- Start Dashboard Top  -->
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div>
                        <!-- Start Tutor Information  -->
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg">
                                    <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.teacher.profileImg" onerror=" this.onerror=null;this.src='assets/images/team/avatar.jpg';" alt="Instructor">
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                    <!-- <div class="rbt-review">
                                        <div class="rating">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                        <span class="rating-count"> (15 Reviews)</span>
                                    </div> -->
                                </div>
                            </div>
                            <div class="rbt-tutor-information-right">
                                <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/create-course/add/0">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text">{{'Create a New Course' | translate}}</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <!-- End Tutor Information  -->
                    </div>
                    <!-- End Dashboard Top  -->

                    <div class="row g-5">
                        <div class="col-lg-3">
                            <!-- Start Dashboard Sidebar  -->
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewProfile(this.teacherId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewCourses(this.teacherId)"><i class="feather-monitor"></i><span>{{'MyCourses' | translate}}</span></a></li>
                                                    <li><a (click)="ViewPayments(this.teacherId)"><i class="feather-dollar-sign"></i><span>{{'payments' | translate}}</span></a></li>
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewSettings(this.teacherId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- End Dashboard Sidebar  -->
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">
                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">{{'View Profile' | translate}}</h4>
                                    </div>
                                    
                                    <div class="rbt-profile-row row row--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'First Name' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.name}}</div>
                                        </div>
                                    </div>
                                    
                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'Last Name' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.surname}}</div>
                                        </div>
                                    </div>
                                    

                                    
                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'User name' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.userName}}</div>
                                        </div>
                                    </div>
                                    

                                    
                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'Email' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.emailAddress}}</div>
                                        </div>
                                    </div>
                                    

                                    
                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'Phone Number' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.mobile}}</div>
                                        </div>
                                    </div>

                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'Registration Date' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.creationTime | date:'fullDate'}}</div>
                                        </div>
                                    </div>

                                    
                                    <div class="rbt-profile-row row row--15 mt--15">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="rbt-profile-content b2">{{'Bio' | translate}}</div>
                                        </div>
                                        <div class="col-lg-8 col-md-8">
                                            <div class="rbt-profile-content b2">{{this.teacher.bio}}</div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
